module.exports = __webpack_public_path__ + "img/logo.282427a5.svg";